package ru.it_mozaika.sender.js.application.components.campaigns

import io.ktor.client.call.*
import js.core.jso
import mui.lab.LoadingButton
import mui.lab.TabContext
import mui.lab.TabList
import mui.lab.TabPanel
import mui.material.*
import mui.system.responsive
import mui.system.sx

import react.*
import react.dom.events.ChangeEvent
import react.dom.events.MouseEvent
import react.dom.html.ReactHTML
import react.dom.onChange
import react.router.useNavigate
import ru.it_mozaika.components.useSnackbar
import ru.it_mozaika.sender.common.EMAIL_REGEX
import ru.it_mozaika.sender.common.models.*
import ru.it_mozaika.sender.common.models.Property
import ru.it_mozaika.sender.js.application.Http
import ru.it_mozaika.utils.checkResponseError
import ru.it_mozaika.sender.js.application.components.SenderSelect
import ru.it_mozaika.sender.js.application.components.StoresSelect
import ru.it_mozaika.sender.js.application.components.SubscriptionListSelect
import ru.it_mozaika.sender.js.application.components.segments.RuleGroup
import ru.it_mozaika.sender.js.application.context.*
import ru.it_mozaika.sender.js.application.frames.MainCard
import web.cssom.*
import web.html.HTMLDivElement
import web.html.HTMLInputElement
import kotlin.reflect.KMutableProperty1

val EmailCampaignEditFrame = VFC {
    var activeStep by useState(0)
    val navigate = useNavigate()

    val campaignContext = useCampaign()
    val selectedSubList = useSubscriptionLists().currentIds

    var properties by useState(emptyList<Property>())
    fun loadProperties(store: String) {
        Http.get("/subscribers/properties", mapOf("store" to store)) { response ->
            response.checkResponseError()?.let {
                return@get
            }
            properties = response.body()
        }
    }
    useEffect(campaignContext.campaign.store) {
        loadProperties(campaignContext.campaign.store)
    }

    var showSendCampaignDialog by useState(false)
    EmailCampaignStartDialog {
        campaign = if (showSendCampaignDialog) campaignContext.campaign else null
        this.onClose = {
            showSendCampaignDialog = false
            if (it) {
                navigate("/campaigns")
            }
        }
    }
        Card {
            sx {
                ":hover" {
                    boxShadow = BoxShadow(0.px, 2.px, 14.px, 0.px, Color("rgb(32 40 45 / 8%)"))
                }
            }
            CardHeader {
                title = ReactNode(if (campaignContext.campaign.id.isBlank()) "Создание" else "Редактирование")
                action = useMemo(campaignContext.campaign, activeStep) {
                    Stack.create {
                        direction = responsive(StackDirection.row)
                        spacing = responsive(1)
                        sx {
                            alignItems = AlignItems.center
                            justifyContent = JustifyContent.flexEnd
                        }
                        Button {
                            variant = ButtonVariant.outlined
                            color = ButtonColor.primary
                            startIcon = mui.icons.material.ArrowBack.create()
                            onClick = { navigate("/campaigns") }
                            +"Назад"
                        }
                        Button {
                            variant = ButtonVariant.contained
                            color = ButtonColor.primary
                            startIcon = mui.icons.material.ContentCopy.create()
                            disabled = campaignContext.campaign.id.isBlank()
                            sx { display = if (campaignContext.campaign.id.isNotBlank()) Display.inlineFlex else None.none }
                            onClick = { navigate("/campaigns/new?id=${campaignContext.campaign.id}") }
                            +"Скопировать"
                        }
//                        Button {
//                            asDynamic().component = "a"
//                            asDynamic().href = "/campaigns/${campaignContext.campaign.id}/preview"
//                            asDynamic().target = "_blank"
//                            variant = ButtonVariant.contained
//                            color = ButtonColor.primary
//                            startIcon = mui.icons.material.Visibility.create()
//                            disabled = campaignContext.campaign.id.isBlank() || !campaignContext.isSaved
//                            sx { display = if (campaignContext.campaign.id.isNotBlank()) Display.inlineFlex else None.none }
//                            +"Предпросмотр"
//                        }
                        Button {
                            variant = ButtonVariant.contained
                            color = ButtonColor.primary
                            startIcon = mui.icons.material.Save.create()
                            onClick = { campaignContext.save() }
                            disabled = campaignContext.isSaved || selectedSubList.isEmpty()
                            +"Сохранить"
                        }
                        Button {
                            variant = ButtonVariant.contained
                            color = ButtonColor.secondary
                            startIcon = mui.icons.material.Send.create()
                            disabled = !campaignContext.isSaved
                            sx { display = if (activeStep == 2) Display.inlineFlex else None.none }
                            onClick = { showSendCampaignDialog = true }
                            +"Отправить"
                        }
                    }
                }
            }
            Divider()
            val steps = listOf("Настройки", "Контент", "Запуск")
            Stepper {
                sx {
                    margin = 24.px
                }
                this.activeStep = activeStep
                nonLinear = true
                steps.forEachIndexed { idx, title ->
                    Step {
                        key = "step$idx"
                        completed = activeStep >= idx
                        disabled = !campaignContext.isSaved
                                || campaignContext.campaign.status == EmailCampaignStatus.Process
                        StepButton {
                            asDynamic().onClick = { _: MouseEvent<HTMLDivElement, *> ->
                                activeStep = idx
                            }
                            +title
                        }
                    }
                }
            }
        }
        when (activeStep) {
            0 -> SettingsFragment {
                this.properties = properties
            }
            1 -> ContentFragment()
            2 -> SendingFragment()
        }
}

private val SendingFragment = VFC {
    val showNotification = useSnackbar().enqueueSnackbar
    val campaignContext = useCampaign()
    var testEmail by useState("")

    TabFragment {
        Grid {
            item = true
            asDynamic().md = 6
            asDynamic().xs = 12
            MainCard {
                title = "Время отправки"
                EmailCampaignStartParameters {
                    this.disabled = false
                    this.startTime = campaignContext.campaign.startDate
                    this.intelligentSending = campaignContext.campaign.intelligentSending
                    this.startTimeChanged = { campaignContext.update(campaignContext.campaign.copy(startDate = it)) }
                    this.intelligentSendingChanged = { campaignContext.update(campaignContext.campaign.copy(intelligentSending = it)) }
                }
            }
        }
        Grid {
            item = true
            asDynamic().md = 6
            asDynamic().xs = 12
            MainCard {
                title = "Тестовый Email"

                FormControl {
                    variant = FormControlVariant.outlined
                    fullWidth = true
                    InputLabel {
                        htmlFor = "input-test-email"
                        +"Email"
                    }
                    OutlinedInput {
                        id = "input-test-email"
                        type = "email"
                        value = testEmail
                        onChange = { testEmail = it.target.asDynamic().value as String }
                        endAdornment = InputAdornment.create {
                            position = InputAdornmentPosition.end
                            IconButton {
                                color = IconButtonColor.primary
                                disabled = if (testEmail.contains(",") || testEmail.contains(";")) {
                                    testEmail.replace(",", ";").split(";").any { !EMAIL_REGEX.matches(it) }
                                } else {
                                    !EMAIL_REGEX.matches(testEmail)
                                }
                                onClick = {
                                    Http.get("/campaigns/${campaignContext.campaign.id}/test-email", mapOf("email" to testEmail, "variant" to "0")) { response ->
                                        response.checkResponseError()?.let { error ->
                                            showNotification(error, jso { variant = AlertColor.error })
                                        } ?: kotlin.run {
                                            showNotification("E-mail отправлен", jso { variant = AlertColor.success })
                                        }
                                    }
                                }
                                edge = IconButtonEdge.end
                                mui.icons.material.Send()
                            }
                        }
                    }
                }
            }
        }
    }
}

private val ContentFragment = VFC {
    val campaignContext = useCampaign()
    var selectedVariant by useState("0")
    var dialogIsOpen by useState(false)

    useEffect(selectedVariant){
        println("selectedVariant - $selectedVariant")
    }

    Dialog{
        open = dialogIsOpen
        DialogTitle{
            + "Вы точно хотите удалить вариант ${selectedVariant.toInt() + 1} ?"
        }
        DialogActions {
            sx {
                alignItems = AlignItems.center
                marginRight = 15.px
            }
            Stack {
                direction = responsive(StackDirection.row)
                spacing = responsive(2)
                Button {
                    variant = ButtonVariant.outlined
                    this.color = ButtonColor.error
                    + "Удалить"
                    this.onClick = {
                        campaignContext.update(campaignContext.campaign.copy(variants = campaignContext.campaign.variants.minus(campaignContext.campaign.variants[selectedVariant.toInt()])))
                        dialogIsOpen = false
                    }
                }
                Button {
                    + "Отмена"
                    color = ButtonColor.secondary
                    variant = ButtonVariant.outlined
                    onClick = {
                        dialogIsOpen = false
                    }
                }
            }
        }
    }

    TabFragment {
        Grid {
            item = true
            asDynamic().xs = 12
            MainCard {
                sx { flexGrow = number(1.0) }
                TabContext {
                    value = selectedVariant
                    Box {
                        sx {
                            borderBottom = Border(1.px, LineStyle.solid)
                            borderColor = Color("divider")
                        }
                        TabList {
                            for (i in 0 until campaignContext.campaign.variants.size) {
                                Tab {
                                    sx {
                                        flexGrow = number(1.0)
                                        maxWidth = None.none
                                    }
                                    onClick = { selectedVariant = i.toString() }
                                    label = ReactNode("Вариант ${i+1}")
                                    value = i.toString()
                                    if (campaignContext.campaign.variants.size > 1) {
                                        iconPosition = IconPosition.end
                                        icon = mui.icons.material.Delete.create {
                                            onClick = {
                                                it.preventDefault()
                                                it.stopPropagation()
                                                if (selectedVariant.toInt() > i) {
                                                    selectedVariant = (selectedVariant.toInt() - 1).toString()
                                                }
                                                dialogIsOpen = true
//                                                campaignContext.update(campaignContext.campaign.copy(variants = campaignContext.campaign.variants.minus(campaignContext.campaign.variants[i])))
                                            }
                                        }
                                    }
                                }
                            }
                            Tab {
                                sx {
                                    flexGrow = number(1.0)
                                    maxWidth = None.none
                                }
                                onClick = {
                                    it.preventDefault()
                                    it.stopPropagation()
                                    selectedVariant = campaignContext.campaign.variants.size.toString()
                                    campaignContext.update(campaignContext.campaign.copy(variants = campaignContext.campaign.variants.plus(campaignContext.campaign.variants.last().copy())))
                                }
                                label = ReactNode("+ Добавить вариант")
                                value = "new"
                            }
                        }
                    }

                    for (i in 0 until campaignContext.campaign.variants.size) {
                        TabPanel {
                            value = i.toString()
                            val templateBlockType = campaignContext.campaign.variants[i].template is EmailTemplate.BlockEditor

                            Grid {
                                container = true
                                direction = responsive(GridDirection.row)
                                sx{
                                    this.justifyContent = JustifyContent.center
                                    alignItems = AlignItems.center
                                }
                                spacing = responsive(2)
                                Grid {
                                    item = true
                                    Button {
                                        variant = ButtonVariant.contained
                                        asDynamic().component = ReactHTML.a
                                        asDynamic().href = "/editor/email?id=${campaignContext.campaign.id}&variant=${selectedVariant.toInt()+1}&type=campaign"
                                        +"Редактировать шаблон"
                                    }
                                }
                                Grid {
                                    item = true
                                    Button {
                                        variant = ButtonVariant.contained
                                        onClick = {
                                            val variants = campaignContext.campaign.variants.toMutableList()
                                            variants[i] = variants[i].copy(template = if (templateBlockType) EmailTemplate.Freemarker() else EmailTemplate.BlockEditor())
                                            campaignContext.update(campaignContext.campaign.copy(variants = variants))
                                        }
                                        +"Преобразовать в ${if (templateBlockType) "HTML" else "Блочную"} версию"
                                    }
                                }
                                Grid{
                                    item = true
                                    Button {
                                        asDynamic().component = "a"
                                        asDynamic().href = "/campaigns/${campaignContext.campaign.id}/preview?variant=$i"
                                        asDynamic().target = "_blank"
                                        variant = ButtonVariant.contained
                                        color = ButtonColor.primary
                                        startIcon = mui.icons.material.Visibility.create()
                                        disabled = campaignContext.campaign.id.isBlank() || !campaignContext.isSaved
                                        sx { display = if (campaignContext.campaign.id.isNotBlank()) Display.inlineFlex else None.none }
                                        +"Предпросмотр"
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

external interface SettingsFragmentProps : Props {
    var disabled: Boolean
    var properties: List<Property>
}
val SettingsFragment = FC<SettingsFragmentProps> { props ->
    val campaignContext = useCampaign()
    val (rules, setRules) = useState(Rule.RuleGroup())
    var size by useState<Int>()
    var isSizeLoading by useState(false)

    useEffect(campaignContext.campaign.segment) {
        campaignContext.campaign.segment?.let {
            setRules(it)
        }
    }
    useEffect(rules) {
        campaignContext.campaign.segment?.let {
            if (rules != it) {
                campaignContext.update(campaignContext.campaign.copy(segment = rules))
            }
        }
    }

    TabFragment {
        Grid {
            item = true
            asDynamic().md = 6
            asDynamic().xs = 12

            MainCard {
                title = "Основная информация"
                sx { flexGrow = number(1.0) }

                Grid {
                    container = true
                    direction = responsive(GridDirection.column)
                    spacing = responsive(2)
                    Grid {
                        item = true
                        TextField {
                            id = "text-field-name"
                            label = ReactNode("Название")
                            variant = FormControlVariant.outlined
                            fullWidth = true
                            value = campaignContext.campaign.name
                            disabled = props.disabled
                            onChange = useMemo(campaignContext.update) {{ e ->
                                campaignContext.update(
                                    campaignContext.campaign.copy(
                                        name = e.unsafeCast<ChangeEvent<HTMLInputElement>>().target.value
                                    )
                                )
                            }}
                        }
                    }
                    Grid {
                        item = true
                        StoresSelect {
                            disabled = props.disabled
                            fullWidth = true
                        }
                    }
                    Grid {
                        item = true
                        SenderSelect {
                            disabled = props.disabled
                        }
                    }
                }
            }
        }
        Grid {
            item = true
            asDynamic().md = 6
            asDynamic().xs = 12

            MainCard {
                title = "Отслеживание"
                sx { flexGrow = number(1.0) }
                Grid {
                    container = true
                    direction = responsive(GridDirection.column)
                    spacing = responsive(2)
                    campaignContext.campaign.utmTags.let { utm ->
                        fun UtmTags.utmInput(fieldId: String, title: String, property: KMutableProperty1<UtmTags, String>) {
                            Grid {
                                item = true
                                TextField {
                                    id = fieldId
                                    label = ReactNode(title)
                                    variant = FormControlVariant.outlined
                                    fullWidth = true
                                    value = property.get(this@utmInput)
                                    disabled = props.disabled
                                    onChange = { e ->
                                        val value = e.unsafeCast<ChangeEvent<HTMLInputElement>>().target.value
                                        val newTags = this@utmInput.copy()
                                        property.set(newTags, value)
                                        campaignContext.update(campaignContext.campaign.copy(utmTags = newTags))
                                    }
                                }
                            }
                        }

                        utm.utmInput("text-field-utm-campaign", "UTM Campaign", UtmTags::campaign)
                        utm.utmInput("text-field-utm-medium", "UTM Medium", UtmTags::medium)
                        utm.utmInput("text-field-utm-source", "UTM Source", UtmTags::source)
                    }
                }
            }
        }

        Grid {
            item = true
            asDynamic().xs = 12
            MainCard {
                title = "Получатели"

                Stack {
                    direction = responsive(StackDirection.row)
                    spacing = responsive(2)

                    Box {
                        sx { flexGrow = number(1.0) }
                        SubscriptionListSelect{
                            isDisabled = campaignContext.campaign.status == EmailCampaignStatus.Complete
                                    || campaignContext.campaign.status == EmailCampaignStatus.Process
                        }
                    }
                    Box {
                        sx { flexGrow = number(1.0) }
                        FormControlLabel {
                            checked = campaignContext.campaign.segment != null
                            control = Switch.create()
                            label = ReactNode("Использовать сегментацию")
                            disabled = !campaignContext.isSaved
                                    || campaignContext.campaign.status == EmailCampaignStatus.Complete
                                    || campaignContext.campaign.status == EmailCampaignStatus.Process
                            onChange = { _, value ->
                                campaignContext.update(campaignContext.campaign.copy(segment = if (value) Rule.RuleGroup() else null))
                            }
                        }
                    }
                    Box {
                        sx { flexGrow = number(1.0) }
                        Tooltip {
                            title = ReactNode("Количество подписчиков")
                            placement = TooltipPlacement.bottom
                            LoadingButton {
                                variant = ButtonVariant.text
                                disabled = !campaignContext.isSaved
                                        || campaignContext.campaign.status == EmailCampaignStatus.Complete
                                        || campaignContext.campaign.status == EmailCampaignStatus.Process
                                loading = isSizeLoading
                                endIcon = mui.icons.material.Update.create()
                                onClick = onClick@{
                                    if (isSizeLoading) {
                                        return@onClick
                                    }
                                    isSizeLoading = true

                                    Http.get("/campaigns/${campaignContext.campaign.id}/size") { response ->
                                        isSizeLoading = false
                                        response.checkResponseError()?.let {
                                            return@get
                                        }
                                        size = response.body<Int>()
                                    }
                                }

                                +when {
                                    isSizeLoading -> ""
                                    size != null -> size?.toString().orEmpty()
                                    else -> "Обновить количество"
                                }
                            }
                        }
                    }
                }

                if (campaignContext.campaign.segment != null && !props.disabled) {
                    RuleGroup {
                        properties = props.properties
                        rule = rules
                        onChange = { setRules(it) }
                        onAddRule = { isGroup ->
                            setRules {
                                it.copy(
                                    rules = it.rules.plus(
                                        if (isGroup) {
                                            Rule.RuleGroup()
                                        } else {
                                            Rule.Segment()
                                        }
                                    )
                                )
                            }
                        }
                    }
                }
            }
        }
    }
}

val TabFragment = FC<PropsWithChildren> { props ->
    Fragment {
        Grid {
            container = true
            direction = responsive(GridDirection.row)
            spacing = responsive(2)
            sx { marginTop = 4.px }
            +props.children
        }
    }
}